import { FormikProps } from 'formik';
import { useRef, useState } from 'react';
import { Container, ProgressBar } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import activeCommerceLogo from '../../../assets/icon-empresa-active.png';
import { AddressTaxesValues, CommerceAddressState } from '../../../types/add_commerce.types';
import { AddressTaxesRequest } from '../../../types/business/request';
import { getProgressPercentage } from '../../../utils/progressHelper';
import AddressFooter from './AddressFooter';
import AddressForm from './AddressForm';

function CommerceAddress() {
  const location = useLocation();
  const formRef = useRef<FormikProps<any> | null>(null);
  const localState: CommerceAddressState = location.state as CommerceAddressState;

  const [addressRequest, setAddressRequest] = useState<AddressTaxesRequest | null>(null);

  const handleSubmit = ({ stateId, ...values }: AddressTaxesValues) => {
    const requestBody: AddressTaxesRequest = {
      ...values,
      cityId: +values.cityId,
      businessType: +values.businessType,
    };

    setAddressRequest(requestBody);
  };

  return (
    <>
      <Container className="address">
        <ProgressBar now={getProgressPercentage('CommerceAddress')} />
        <h1>
          <img src={activeCommerceLogo} alt="" className="me-3" /> Domicilio principal
        </h1>
        <br />
        <AddressForm formRef={formRef} localState={localState} handleSubmit={handleSubmit} />
      </Container>
      <AddressFooter formRef={formRef} localState={localState} addressRequest={addressRequest} />
    </>
  );
}

export default CommerceAddress;
